import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle, Brain, MessageSquare } from 'lucide-react';
export function TrapsSection() {
  const traps = [{
    icon: AlertTriangle,
    title: 'Esperar sentir ganas',
    desc: 'No van a llegar. Estás drenado.'
  }, {
    icon: XCircle,
    title: 'Renunciar en un arranque',
    desc: 'Eso no es libertad. Eso es pánico con consecuencias.'
  }, {
    icon: Brain,
    title: 'Consejos genéricos',
    desc: 'Ayuda, sí… pero mañana a las 7am igual tienes que entrar.'
  }, {
    icon: MessageSquare,
    title: 'Hablar de más',
    desc: 'Un desahogo mal elegido te cuesta turnos, horas, reputación… o tu puesto.'
  }];
  return <Section variant="darker" className="border-t border-neutral-900" data-id="element-149">
      <h2 className="text-3xl font-bold text-white uppercase tracking-tight mb-10 text-center" data-id="element-150">
        Las 4 trampas que te mantienen atrapado
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-151">
        {traps.map((trap, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-neutral-900 p-6 rounded-xl border border-neutral-800 hover:border-red-900/50 transition-colors" data-id="element-152">
            <div className="flex items-start gap-4" data-id="element-153">
              <div className="bg-neutral-800 p-3 rounded-lg text-red-500" data-id="element-154">
                <trap.icon size={24} data-id="element-155" />
              </div>
              <div data-id="element-156">
                <h3 className="text-white font-bold text-lg mb-2" data-id="element-157">
                  Trampa #{i + 1}: {trap.title}
                </h3>
                <p className="text-neutral-400 leading-relaxed" data-id="element-158">{trap.desc}</p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}